<template>
    <div>
        <b-modal v-model="showDetails" size="lg" :title="title">
            <div class="row">
                <div class="col col-12" id="json">
                    <pre>{{ writeData }}</pre>
                </div>
            </div>

            <template v-slot:modal-footer>
                <div class="row">
                    <b-btn-group class="mr-2">
                        <b-btn block variant="default" @click="closeDetails">Fechar</b-btn>
                    </b-btn-group>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
  props: {
    title: { default: 'json' }
  },
  data () {
    return {
      showDetails: false,
      writeData: ''
    }
  },
  methods: {
    closeDetails () {
      this.showDetails = false
    },
    openModal (data) {
      let th = this
      th.showDetails = true
      th.writeData = JSON.parse(data)
    }
  }
}
</script>
